module.exports = __webpack_public_path__ + "static/renfrew-logo-bf3370380483e0c1ddecd83b3b4387bd.jpeg";